import contactItemTemplate from './contactItem.html';

const contactItem = {
    bindings: {
        contact: '=',
        deleteItem: '&',
        advindaContactsCount: '@?',
        customContactsCount: '@?',
        assignedContacts: '=',
        assignedCustomContacts: '=',
    },
    template: contactItemTemplate,
    controller: function ($state) {
        this.$onInit = () => {
            this.isCustomerContact = !!this.contact.contactInfo.contact
                .customer;
        };

        this.deleteContact = () => {
            this.deleteItem(this.contact);
        };

        this.addToAssignList = () => {
            if (this.contact.checked) {
                this.isCustomerContact
                    ? this.assignedCustomContacts.add(
                          this.contact.contactInfo.contact.id
                      )
                    : this.assignedContacts.add(
                          this.contact.contactInfo.contact.id
                      );
            } else {
                this.isCustomerContact
                    ? this.assignedCustomContacts.delete(
                          this.contact.contactInfo.contact.id
                      )
                    : this.assignedContacts.delete(
                          this.contact.contactInfo.contact.id
                      );
            }
        };

        this.getContactUrl = (contId) => {
            if (this.isCustomerContact) {
                return $state.href(
                    'customerContactsDetail',
                    {
                        contactId: contId,
                        isCustomerContact: true,
                        advindaCount: this.advindaContactsCount,
                        customCount: this.customContactsCount,
                    },
                    { reload: true }
                );
            } else {
                return $state.href(
                    'contactsDetail',
                    {
                        contactId: contId,
                        isCustomerContact: false,
                        advindaCount: this.advindaContactsCount,
                        customCount: this.customContactsCount,
                    },
                    { reload: true }
                );
            }
        };
    },
};

export default contactItem;



/** WEBPACK FOOTER **
 ** ./src/app/directives/contactList/contactItem.js
 **/